import { Link } from 'react-router-dom';
import ScrollReveal from '../components/ScrollReveal';

export default function Udlejning() {
  const partyProducts = [
    {
      name: 'Slushice maskine',
      price: 'Fra 450kr pr døgn',
      path: '/udlejning/slushice-maskine',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/imgi-73-498030673-122133800990785719-4494842369837955426-n.jpg',
      details: [
        'Hele weekenden for 600kr',
        'Et døgn er fra kl 11:00 til 11:00',
        'En weekend er fra Fredag kl 11:00 til Søndag kl 11:00'
      ]
    },
    {
      name: 'Popcorn maskine',
      price: 'Pris fra 500kr pr døgn',
      path: '/udlejning/popcorn-maskine',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/thumbnail-emne_1.png',
      details: [
        'Pris fra 500kr pr døgn med Popcorn Mix til 40 personer.'
      ]
    },
    {
      name: 'Soundbox 3',
      price: '300kr pr døgn',
      path: '/udlejning/soundbox-3',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/84984-3_2.jpg',
      details: [
        '300kr pr døgn'
      ]
    },
    {
      name: 'Hoppeborg',
      price: '1500kr pr døgn',
      path: '/udlejning/hoppeborg',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image18_3.jpeg',
      details: [
        '1500kr',
        'Pr døgn',
        'Prisen er med levering, opsætning og afhentning.'
      ]
    },
    {
      name: 'Pølsevogn / Pølsemaskine',
      price: 'Fra 1500kr pr døgn',
      path: '/udlejning/poelsevogn',
      image: 'https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/image22.jpeg',
      details: [
        'Pris fra 1500kr pr døgn',
        'Nem betjening og hurtig opvarmning',
        'Mulighed for tilkøb af komplet pølsemix (pølser, brød og tilbehør)'
      ]
    }
  ];

  return (
    <div className="flex min-h-screen flex-col bg-stone-50">
      <section className="relative overflow-hidden border-b border-stone-200 bg-white py-20">
        <div className="absolute inset-0 opacity-35">
          <img
            src="https://assets.auxodev.dk/assets/27b85900-9717-41d2-8622-634ea09330b6/hero-excavator.jpg"
            alt="Baggrund for udlejning"
            className="h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-white/50" />
        </div>
        <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <ScrollReveal animation="fade-in-down">
            <span className="text-xs font-bold uppercase tracking-[0.35em] text-brand-orange">Festudlejning</span>
            <h1 className="mt-3 text-4xl font-semibold text-slate-800 sm:text-5xl">Udlejning til din næste fest</h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-500 sm:text-base">
              Gør din fest uforglemmelig med vores udvalg af sjove maskiner og professionelt udstyr. Vi leverer, opsætter og afhenter, så du kan fokusere på dine gæster.
            </p>
          </ScrollReveal>
          <ScrollReveal animation="scale-up" delay={150} className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href="tel:22426011"
              className="rounded-full bg-brand-orange px-6 py-3 text-base font-bold text-white transition-all duration-300 hover:bg-brand-orange-hover hover:-translate-y-0.5 hover:shadow-lg"
            >
              <i className="fa-solid fa-phone mr-2" /> 22 42 60 11
            </a>
            <Link
              to="/kontakt"
              className="rounded-full border border-stone-200 bg-white px-6 py-3 text-base font-bold text-slate-700 transition-all duration-300 hover:border-brand-orange hover:text-brand-orange hover:-translate-y-0.5 hover:shadow-md"
            >
              Forespørg leje
            </Link>
          </ScrollReveal>
        </div>
      </section>

      <section className="flex-grow py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            {partyProducts.map((product, idx) => (
              <ScrollReveal
                key={idx}
                animation="fade-in-up"
                delay={idx * 100}
              >
                <Link
                  to={product.path}
                  className="group flex flex-col overflow-hidden rounded-[1.5rem] border border-stone-200 bg-white shadow-[0_12px_30px_rgba(148,163,184,0.08)] md:flex-row transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:border-brand-orange/30 h-full"
                >
                  <div className="relative h-64 overflow-hidden bg-stone-100 md:h-auto md:w-1/2 shrink-0">
                    <img
                      src={`https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=85,format=auto/${product.image}`}
                      alt={product.name}
                      className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute left-4 top-4 rounded-full bg-brand-orange px-3 py-1 text-xs font-bold text-white shadow-md">
                      {product.price}
                    </div>
                  </div>

                  <div className="flex flex-col justify-between p-8 md:w-1/2 flex-grow">
                    <div>
                      <span className="text-xs font-bold uppercase tracking-[0.35em] text-brand-orange">Festudstyr</span>
                      <h2 className="mt-1 mb-4 text-2xl font-semibold text-slate-800 group-hover:text-brand-orange transition-colors">{product.name}</h2>
                      <ul className="mb-6 space-y-2.5 text-sm text-slate-500">
                        {product.details.map((detail, dIdx) => (
                          <li key={dIdx} className="flex items-start gap-2">
                            <i className="fa-solid fa-circle mt-2 shrink-0 text-[6px] text-brand-orange" />
                            <span>{detail}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mt-auto flex items-center justify-between border-t border-stone-200 pt-4 text-xs font-bold uppercase tracking-wider text-brand-orange">
                      <span>Se detaljer</span>
                      <i className="fa-solid fa-chevron-right transition-transform group-hover:translate-x-1" />
                    </div>
                  </div>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
